// In src/pages/llm-response/index.tsx
import LLMResponseTool from 'src/components/llm-response'; // Default import

// import AdminToolInfo from "../../components/admin-tool-info";

const LLMResponse: React.FC = () => {
	return <LLMResponseTool />;
};
export default LLMResponse;
